/* ==========================================================================
   Voile Chic — add to cart opens the drawer

   This file goes through the theme's own drawer component. It does not write
   drawer classes itself.

   CartDrawerSection.toggleDrawerClasses() sets three things in one step: the
   `open` attribute on <cart-drawer>, `wt-cart__drawer--open` on #CartDrawer,
   and `page-overlay-cart-on` on <body>. An earlier version of this file set
   the body class directly and added an `active` class that no stylesheet in
   this theme defines. Below 600px cart-drawer.css hides every child of <body>
   while that body class is on, so the result on a phone was a white screen
   with the panel still parked off-screen — and because the component toggles
   rather than sets, the next tap inverted the state again, so only a reload
   recovered it.

   Three rules now hold:
     - open and close only ever run through the component
     - the drawer opens off the repaint actually landing, not off a timer
     - a watchdog clears a backdrop left up with the drawer shut
   ========================================================================== */

(function () {
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var OPEN_CLASS = 'wt-cart__drawer--open';
  var BODY_CLASS = 'page-overlay-cart-on';

  /* How long after a toggle the watchdog leaves the state alone. */
  var GRACE = 700;

  var adding = false;
  var guardUntil = 0;
  var toggledAt = 0;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function drawerEl() {
    return document.querySelector('cart-drawer');
  }

  function panel() {
    return document.getElementById('CartDrawer');
  }

  /* On the cart page the component never wires up its triggers, so there is
     no drawer to open. */
  function cartIsAPage() {
    var el = drawerEl();
    if (el && el.dataset && el.dataset.cartType === 'page') return true;
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return window.location.pathname === cartUrl;
  }

  /* The open state as the theme itself records it. */
  function isOpen() {
    var el = drawerEl();
    var p = panel();
    return !!((el && el.hasAttribute('open')) || (p && p.classList.contains(OPEN_CLASS)));
  }

  function toggleViaTheme() {
    var el = drawerEl();
    if (!el || typeof el.toggleDrawerClasses !== 'function') return false;
    try {
      toggledAt = Date.now();
      el.toggleDrawerClasses();
      return true;
    } catch (e) {
      return false;
    }
  }

  function openDrawer() {
    if (cartIsAPage() || isOpen()) return;

    if (toggleViaTheme() && isOpen()) return;

    /* Falling back to the header link runs the component's own handler. */
    var trigger = document.querySelector('.wt-cart__trigger');
    if (trigger) {
      toggledAt = Date.now();
      trigger.click();
    }
  }

  /* ---------- Watchdog ---------------------------------------------------- */
  /* The backdrop class and the open state are set together, so a backdrop with
     the drawer shut is always a fault, and on a phone it is an invisible page.
     Nothing else in this theme uses this body class: every other drawer has
     its own overlay class, so clearing it here cannot disturb them. */

  function clearStrandedBackdrop() {
    var el = drawerEl();
    var p = panel();

    document.body.classList.remove(BODY_CLASS);
    if (p) p.classList.remove(OPEN_CLASS);
    if (el) {
      el.removeAttribute('open');
      try {
        el.isOpen = false;
      } catch (e) {
        /* read-only in some engines */
      }
    }

    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.documentElement.style.overflow = '';
  }

  function reconcile() {
    if (!document.body.classList.contains(BODY_CLASS)) return;
    if (isOpen()) return;
    if (Date.now() - toggledAt < GRACE) return;
    clearStrandedBackdrop();
  }

  setInterval(reconcile, 400);

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) reconcile();
  });

  window.addEventListener('pageshow', reconcile);

  /* Closing is the component's job; only note when it happened so the
     watchdog does not fire mid-transition. */
  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest) return;
      if (
        event.target.closest('.wt-cart__drawer__close--button') ||
        event.target.closest('.wt-cart__drawer__close') ||
        (event.target.classList && event.target.classList.contains('page-overlay-cart'))
      ) {
        toggledAt = Date.now();
        setTimeout(reconcile, 900);
      }
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      toggledAt = Date.now();
      setTimeout(reconcile, 900);
    }
  });

  /* ---------- Keep the shopper on the page -------------------------------- */
  /* Some add-to-cart paths fall back to a full page load of /cart. While an
     add is in flight that navigation is suppressed so the drawer can answer
     instead. */

  function guard() {
    guardUntil = Date.now() + 6000;
  }

  function guarding() {
    return Date.now() < guardUntil;
  }

  var assign = window.location.assign.bind(window.location);
  var replace = window.location.replace.bind(window.location);

  function isCartUrl(url) {
    return /\/cart(\?|$|#)/.test(String(url || ''));
  }

  try {
    window.location.assign = function (url) {
      if (guarding() && isCartUrl(url)) return;
      assign(url);
    };
    window.location.replace = function (url) {
      if (guarding() && isCartUrl(url)) return;
      replace(url);
    };
  } catch (e) {
    /* Some browsers refuse to patch location. */
  }

  /* ---------- Adding ------------------------------------------------------ */

  function render(json) {
    var el = drawerEl();
    if (el && json && json.sections && typeof el.renderContents === 'function') {
      try {
        el.renderContents({ sections: json.sections, items: json.items }, false);
        return;
      } catch (e) {
        /* fall through to a full refresh */
      }
    }
    document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { bubbles: true }));
  }

  /* The sticky bars sit outside the product form, so they post it themselves. */
  function addFromForm(button) {
    if (adding) return;

    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    adding = true;
    guard();
    if (button) button.classList.add('loading');

    var data = new FormData(form);
    data.append('sections', SECTIONS);
    data.append('sections_url', window.location.pathname);

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (json) {
        adding = false;
        if (button) button.classList.remove('loading');
        if (json && json.status) return;

        /* Contents first, then open — never an empty panel. */
        render(json);

        if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'vc-sticky',
            cartData: json
          });
        }

        openDrawer();
      })
      .catch(function () {
        adding = false;
        if (button) button.classList.remove('loading');
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest) return;

      var sticky = event.target.closest('.vc-sticky-bar__atc, .vc-mobile-sticky__atc');
      if (sticky) {
        event.preventDefault();
        event.stopImmediatePropagation();
        addFromForm(sticky);
        return;
      }

      var btn = event.target.closest(
        '[name="add"], .product-form__submit, button[data-add-to-cart], .wt-button--add-to-cart'
      );
      if (!btn || btn.disabled) return;

      /* The theme posts this button itself and repaints the drawer without
         opening it. The repaint fires vc:cart:rendered, which is what opens
         the drawer; these timers are only a backstop for paths that do not
         repaint at all. Opening twice is a no-op. */
      guard();
      setTimeout(openDrawer, 1200);
      setTimeout(openDrawer, 2600);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (form && form.action && form.action.indexOf('/cart/add') !== -1) {
        guard();
        setTimeout(openDrawer, 1200);
        setTimeout(openDrawer, 2600);
      }
    },
    true
  );

  /* The component fires this once a repaint has actually landed — the moment
     the drawer genuinely has the new line in it. */
  document.addEventListener('vc:cart:rendered', function () {
    if (guarding()) openDrawer();
  });

  /* An add that finishes early opens the drawer straight away. Quantity edits
     made inside the drawer publish with source "cart-items" and are ignored. */
  if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (payload) {
      if (payload && payload.source === 'cart-items') return;
      openDrawer();
    });
  }

  ['ajaxProduct:added', 'on:cart:add', 'cart:added'].forEach(function (ev) {
    document.addEventListener(ev, function () {
      if (guarding()) openDrawer();
    });
  });

  document.addEventListener('DOMContentLoaded', reconcile);
})();
